export const loaderSelector = state => state.loader;
export const getLoaderByName = (state, name) => state.loader[name];
